import { createFileRoute, defaultParseSearch, redirect } from '@tanstack/react-router'
import { BillList, billSearchSchema } from '@/features/bill/index.ts'
import { usePersistedListQuery } from '@/hooks/use-persisted-list-query.ts'
import { createListQueryPersistence } from '@/utils/list-query-persistence.ts'

const listQuery = createListQueryPersistence('super-mega:finance:bills:list-query', billSearchSchema)

export const Route = createFileRoute('/_authenticated/finance/bills')({
  beforeLoad: (options) => {
    // 旧应付入口转到独立支出台账；两种资源的 ID 和查询条件不能混用。
    const legacySearch = defaultParseSearch(options.location.searchStr)
    if ('direction' in legacySearch && legacySearch.direction === 'payable') {
      throw redirect({ to: '/finance/expenses', search: { current: 1, pageSize: 20 }, replace: true })
    }
    listQuery.restore(options)
  },
  validateSearch: listQuery.validateSearch,
  head: () => ({ meta: [{ title: '收款账单 · Super Mega' }] }),
  component: BillsPage
})
function BillsPage() {
  const { currentSession } = Route.useRouteContext()
  const { search, navigateSearch } = usePersistedListQuery({
    persistence: listQuery,
    raw: Route.useSearch(),
    accountId: currentSession.id,
    navigate: Route.useNavigate()
  })
  return <BillList currentSession={currentSession} search={search} navigateSearch={navigateSearch} />
}
